<template>
  <div class="promotion-type" :class="{ active }" @click="$emit('click')">
    <div class="promotion-type__icon" v-if="icon">
      <svgicon :src="icon" :height="80" :width="80"></svgicon>
    </div>
    <div class="promotion-type__content">
      <svgicon class="promotion-type__checkbox" :height="16" :width="16"
               :src="active ? 'icon/check-circle-full.svg' : 'icon/circle.svg'"></svgicon>
      <div class="promotion-type__name">{{ name }}</div>
      <div class="promotion-type__description">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionType",

  props: {
    active: Boolean,
    icon: String,
    name: String,
    description: String
  }
}
</script>

<style lang="scss">
.promotion-type {
  flex-basis: 0;
  flex-grow: 1;
  padding: 8px 32px 8px 8px;
  display: flex;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  position: relative;
  border: 2px solid white;
  cursor: pointer;

  &.active {
    border-color: #fc6650;

    .promotion-type__checkbox {
      fill: #fc6650;
    }

    .promotion-type__icon {
      background: linear-gradient(135deg, #ED2937 0%, #FC6650 100%);
      fill: white;
    }
  }

  &:first-child {
    margin-right: 32px;
  }

  .promotion-type__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .promotion-type__checkbox {
    position: absolute;
    fill: #e6e6e6;
    top: 16px;
    right: 16px;
  }

  .promotion-type__icon {
    border-radius: 8px;
    padding: 32px;
    background-color: #fafafa;
    fill: #fc6650;
    margin-right: 24px;
  }

  .promotion-type__name {
    color: #1a1a1a;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .promotion-type__description {
    color: #808080;
    font-size: 13px;
  }
}
</style>